// Envio de comando por SMS via Veye (backend próprio do GPS Drive) —
// substitui por completo o gateway de SMS do Traccar (ver
// VehicleSendCommandDialog). Atrás de authGuard normal de empresa (não
// platformAuthGuard — isso é sobre a empresa logada usar seu próprio
// saldo, diferente do painel Super Master em /master/sms).
import { gpsDriveGet, gpsDrivePost } from "@/lib/api/gpsdrive-client";

export interface SmsAccountStatus {
  companyId: string;
  companyName: string;
  enabled: boolean;
  balance: number;
  updatedAt: string;
}

export interface SendSmsCommandInput {
  deviceId: number;
  gt06CommandId?: string;
  customText?: string;
  // Equipamento só-SMS: backend grava o estado no device (ver
  // send-block-command-with-sms-fallback.ts).
  recordBlockState?: boolean;
}

export interface SendSmsCommandResult {
  sent: true;
  balanceAfter: number;
  blockStateRecorded?: boolean | null;
}

export const smsSendService = {
  getOwnAccount: () => gpsDriveGet<SmsAccountStatus>("/api/v1/sms-credits/me"),
  send: (input: SendSmsCommandInput) => gpsDrivePost<SendSmsCommandResult>("/api/v1/sms-send", input),
};
